<template>
	<BaseLoading v-if="isLoading" is-full-page />
	<OnSiteMessagePopupForm
		v-else
		is-edit-mode
		:is-loading="isLoading"
		:is-updating="isUpdating"
		:data="data"
		@onSubmit="handleSubmit"
	/>
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex';

import OnSiteMessagePopupForm from '@/components/OnSiteMessagePopupForm.vue';

import { ROUTE_NAME } from '../enums/route';
import { ON_SITE_MESSAGE_COMPONENTS } from '../enums/onSiteMessages';
import { scrollToTop } from '../assets/js/helpers';

export default {
	name: 'OnSiteMessagePopupEdit',

	components: {
		OnSiteMessagePopupForm,
	},

	data() {
		return {
			id: Number(this.$route.params.id) || null,
		};
	},

	computed: {
		...mapState('onSiteMessages', {
			edit: 'edit',
		}),

		...mapGetters({
			getCampaignDetail: 'onSiteMessages/getCampaignDetail',
		}),

		isLoading() {
			return this.edit.isLoading;
		},

		isUpdating() {
			return this.edit.isUpdating;
		},

		data() {
			return this.getCampaignDetail;
		},
	},

	async created() {
		await this.getPopupCampaign(this.id);

		this.setPageTitle({
			title: this.data.name,
			isShow: true,
		});

		this.addBreadcrumb({
			title: ON_SITE_MESSAGE_COMPONENTS.ON_SITE_MESSAGE_POPUP.title,
			route: {
				name: ROUTE_NAME.ON_SITE_MESSAGE_POPUP_LIST,
			},
		});
	},

	methods: {
		...mapActions({
			showToast: 'toast/showToast',
			addBreadcrumb: 'breadcrumb/addBreadcrumb',
			setPageTitle: 'pageTitle/setPageTitle',

			updatePopupCampaign: 'onSiteMessages/updatePopupCampaign',
			getPopupCampaign: 'onSiteMessages/getPopupCampaign',
		}),

		async handleSubmit(updatedData) {
			try {
				await this.updatePopupCampaign({ id: this.id, params: updatedData });
			} catch {
				scrollToTop();
			}
		},
	},
};
</script>
